import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FormPrep from './FormPrep';
import FormBudget from './FormBudget';
import FormActuals from './FormActuals';
import FormBacklog from './FormBacklog';
import FormCash from './FormCash';
import FormStaff from './FormStaff';
import FormWip from './FormWip';
import FormPerformance from './FormPerformance';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBackIcon from '@mui/icons-material/NavigateBefore';
import SkipNextIcon from '@mui/icons-material/SkipNext';

const steps = ['Prep','Budget', 'Actuals', 'Cash','Backlog','Staff and Revenue','Performance','WIP'];

function Financials(props)
{
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = (e) => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }
        
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
        if(activeStep+1===steps.length) //Because of state I have to check +1
        {  
          //Submit the input
          props.submitValues();
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleSkip = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped((prevSkipped) => {
            const newSkipped = new Set(prevSkipped.values());
            newSkipped.add(activeStep);
            return newSkipped;
        });
    };

    const handleSubmit = () => {
        
    };

    const renderStep = (step)=>{
        switch(step)
        {
            case 0:
                return (<FormPrep selectedFinancial={props.selectedFinancial} setSelectedFinancial={props.setSelectedFinancial} allowNew={props.allowNew} peerGroups={props.peerGroups}></FormPrep>);
            case 1:
                return (<FormBudget selectedFinancial={props.selectedFinancial} setSelectedFinancial={props.setSelectedFinancial}></FormBudget>)
            case 2:
                return (<FormActuals selectedFinancial={props.selectedFinancial} setSelectedFinancial={props.setSelectedFinancial}></FormActuals>)
            case 3:
                return (<FormCash selectedFinancial={props.selectedFinancial} setSelectedFinancial={props.setSelectedFinancial}></FormCash>)
            case 4:
                return (<FormBacklog selectedFinancial={props.selectedFinancial} setSelectedFinancial={props.setSelectedFinancial}></FormBacklog>)
            case 5:
                return (<FormStaff selectedFinancial={props.selectedFinancial} setSelectedFinancial={props.setSelectedFinancial}></FormStaff>)
            case 6:
                return (<FormPerformance selectedFinancial={props.selectedFinancial} setSelectedFinancial={props.setSelectedFinancial}></FormPerformance>)
            case 7:
                return (<FormWip selectedFinancial={props.selectedFinancial} setSelectedFinancial={props.setSelectedFinancial}></FormWip>)
            default:
                return (<></>);
        }
    }
  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps = {};
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      
      <Box sx={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Box sx={{ flex: '1 1 auto' }} />
              {/* Submit button moved to footer to prevent jumping */}
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {renderStep(activeStep)}
          </React.Fragment>
        )}
      </Box>
      
      {/* Fixed navigation footer */}
      <Box sx={{ 
        position: 'sticky',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        borderTop: '1px solid #ddd',
        padding: '10px',
        zIndex: 10
      }}>
        <div className="footerRow">
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, flex: 1, minHeight: 1 }}>
            {activeStep === steps.length ? (
              // Show submit button in footer when on final step
              <>
                <Box sx={{ flex: '1 1 auto' }} />
                <Button onClick={handleSubmit} variant='outlined' size="large">
                  Submit
                </Button>
              </>
            ) : (
              // Show navigation buttons for other steps
              <>
                <Button
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                  variant='outlined'
                  startIcon={<NavigateBackIcon/>}
                  tabIndex={1}
                >
                  Back
                </Button>
                <Box sx={{ flex: '1 1 auto' }} />
                <Button 
                  onClick={handleSkip} 
                  sx={{ mr: 1 }} 
                  tabIndex={1} 
                  variant='outlined' 
                  startIcon={<SkipNextIcon/>}
                >
                  Skip
                </Button>
                <Button 
                  onClick={handleNext} 
                  variant='outlined'
                  tabIndex={0}
                  startIcon={<NavigateNextIcon/>}
                >
                  {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                </Button>
              </>
            )}
          </Box>
        </div>
      </Box>
    </Box>
  );
}

export default Financials;